var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'mini-store';
import { AddOutlined, ReduceFunc } from '@feb-team/legao-icons-react';
var ExpandableRow = /** @class */ (function (_super) {
    __extends(ExpandableRow, _super);
    function ExpandableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.renderExpandIcon = function () {
            var expanded = _this.props.expanded;
            if (_this.expandable) {
                if (expanded) {
                    return React.createElement(ReduceFunc, { className: "expand-icon", onClick: function (e) { return _this.handleExpandChange(); } });
                }
                else {
                    return React.createElement(AddOutlined, { className: "expand-icon", onClick: function (e) { return _this.handleExpandChange(); } });
                }
            }
            else {
                return null;
            }
        };
        _this.hasExpandIcon = function (columnIndex) {
            var _a = _this.props, expandRowByClick = _a.expandRowByClick, expandIcon = _a.expandIcon;
            if (_this.expandIconAsCell || columnIndex !== _this.expandIconColumnIndex) {
                return false;
            }
            return !!expandIcon || !expandRowByClick;
        };
        _this.renderExpandIconCell = function (cells) {
            if (!_this.expandIconAsCell) {
                return;
            }
            cells.push(React.createElement("td", { key: "table-expand-icon-cell", className: "expand-icon-cell" }, _this.renderExpandIcon()));
        };
        return _this;
    }
    ExpandableRow.prototype.handleExpandChange = function (record, event) {
        var _a = this.props, rowKey = _a.rowKey, onExpandedChange = _a.onExpandedChange, expanded = _a.expanded;
        if (this.expandable) {
            onExpandedChange(!expanded, record, event, rowKey);
        }
    };
    ExpandableRow.prototype.render = function () {
        var _a = this.props, children = _a.children, expandedRowRender = _a.expandedRowRender, expandIconAsCell = _a.expandIconAsCell, expandIconColumnIndex = _a.expandIconColumnIndex, fixed = _a.fixed, expanded = _a.expanded;
        this.expandable = !!expandedRowRender;
        this.expandIconAsCell = fixed !== 'right' ? expandIconAsCell : false;
        this.expandIconColumnIndex = fixed !== 'right' ? expandIconColumnIndex : -1;
        var expandableRowProps = {
            // TODO
            expanded: expanded,
            renderExpandIconCell: this.renderExpandIconCell,
            renderExpandIcon: this.renderExpandIcon,
            hasExpandIcon: this.hasExpandIcon,
        };
        return children(expandableRowProps);
    };
    return ExpandableRow;
}(Component));
export default connect(function (_a, _b) {
    var _c = _a.expandedRowKeys, expandedRowKeys = _c === void 0 ? [] : _c;
    var rowKey = _b.rowKey;
    return ({
        expanded: expandedRowKeys.includes(rowKey),
    });
})(ExpandableRow);
